// extracted by mini-css-extract-plugin
module.exports = {"recipesContainer":"recipesList_recipesContainer__1SdcV","recipe":"recipesList_recipe__3ykse","noRecipes":"recipesList_noRecipes__3YLbm"};